import { MHTTPCL, JSON_STRING } from "../../../../services/http/http-client";
import { DISTRIBUTION_URL,LABEL_URL,JSONAPI_URL, MODIFICATION_URL,FILE_URL ,CONTACTS_URL} from "../../../../services/common-urls";
import { LabelsCatalogData } from "../../store/types";


export const artistsService={
    getArtists:()=>MHTTPCL.get(LABEL_URL,{
        section:'artists',
    
    }),
    retrieveArtistsPage:(startrow)=>MHTTPCL.post(LABEL_URL,{
        section:	"artists",
        action:	"retrieve_artists_page",
        tableID:	"artistsTable",
        startrow:	startrow,
        output:JSON_STRING

    }),

    searchArtists:(search)=>MHTTPCL.post(LABEL_URL,{
        section:"artists",
        action:	"search_artists",
        search:search,
        tableID	:"artistsTable",
        output:JSON_STRING
    

    }),

    newArtist:(artist_name)=>MHTTPCL.post(LABEL_URL,{
        
        section:"artists",
        action:	"new_artist",
        artist_name:artist_name,
        output:JSON_STRING
    
    }),

    artistDetails:(label_artist_id)=>MHTTPCL.get(LABEL_URL,{
        section:"artists",
        action:"artist_details",
        label_artist_id:label_artist_id

    }),

    artistDetailsTabOverview:(label_artist_id)=>MHTTPCL.get(LABEL_URL,{
        section:"artists",
        action:"artist_details_tab_overview",
        label_artist_id:label_artist_id
	
    }),

    addDefaultCredit:(label_artist_id, type ,name,percentage)=>MHTTPCL.post(LABEL_URL,{
        section:"artists",
        action:"add_default_credit",
        label_artist_id:label_artist_id,
        type:type,
        name:name,
        percentage:percentage
    }),
    removeDefaultCredit:(track_info_id)=>MHTTPCL.post(LABEL_URL,{
        section	: "artists",
        action	: "remove_default_credit",
        track_info_id : track_info_id
    }),

    unrelatedReleases:(label_artist_id)=>MHTTPCL.get(LABEL_URL,{
        section:"artists",
        action:"unrelated_releases",
        label_artist_id:label_artist_id
        
    }),

    searchUnrelatedReleases:(search ,label_artist_id)=>MHTTPCL.post(LABEL_URL,{
        section:"artists",
        action:	"search_unrelated_releases",
        search:search,
        //tableID:"artist_generalurTable1238",
        output:JSON_STRING,
        label_artist_id	:label_artist_id
    }),

    removeRelatedReleaseToArtist:(relation_id)=>MHTTPCL.post(LABEL_URL,{
        section:"artists",
        action:	"remove_related_release_to_artist",
        relation_id:relation_id
        
    }),

    artistDetailsTabText:(label_artist_id)=>MHTTPCL.get(LABEL_URL,{
        section:"artists",
        action : "artist_details_tab_text",
        label_artist_id:label_artist_id,
        output: JSON_STRING
    }).then(res => {
        return {
            ...res,
            data: {
                ...(res.data || {}),
                artwork1: `${MHTTPCL.getBaseUrl()}/files.pl?action=show_file&file_id=${res.data?.artist?.artwork1}`,
                artwork2: `${MHTTPCL.getBaseUrl()}/files.pl?action=show_file&file_id=${res.data?.artist?.artwork2}`,
            }
        }
    }),

    artistDetailsTabBookings:(label_artist_id)=>MHTTPCL.get(LABEL_URL,{
        section : "artists",
        action: "artist_details_tab_bookings",
        label_artist_id:label_artist_id
    }),

    unrelatedBookingArtistForm:(label_artist_id)=>MHTTPCL.get(LABEL_URL,{
        section : "artists",
        action : "unrelated_booking_artist_form",
        label_artist_id : label_artist_id
        
    }),

    addRrelatedBookingArtist:(external_id2,external_id)=>MHTTPCL.get(LABEL_URL,{

        section:"artists",
        action:"add_related_booking_artist",
        external_id2:external_id2,
        external_id:external_id,
        external_table:"label_artist",
        external_table2:"booking_artist"
    }),

    loadRelatedBookingArtists:(label_artist_id)=>MHTTPCL.get(LABEL_URL,{
        section : "artists",
        action : "load_related_booking_artists",
        label_artist_id:label_artist_id
    }),
    
    removeRelatedBookingArtist:(relation_id)=>MHTTPCL.post(LABEL_URL,{
        section	: "artists",
        action	: "remove_related_booking_artist",
        relation_id	:relation_id
        
    }),

    loadRelatedBookings:(label_artist_id)=>MHTTPCL.get(LABEL_URL,{
        section:"artists",
        action:"load_related_bookings",
        label_artist_id:label_artist_id
        
    }),

    addRelatedReleasesToArtist:(external_id,releases,release_ids)=>MHTTPCL.get(LABEL_URL,{
        section:"artists",
        action:"add_related_releases_to_artist",
        external_id:external_id,
        external_table:"artist",
        external_table2:"release",
        releases:releases,
        release_ids:release_ids

    }),

    artistDetailsTabMetadata:(label_artist_id)=>MHTTPCL.get(LABEL_URL,{
        section:"artists",
        action:"artist_details_tab_metadata",
        label_artist_id:label_artist_id,
        output:JSON_STRING
        
    }),

    showMetadata:(external_id)=>MHTTPCL.post(LABEL_URL,{
        action:"show_metadata",
        external_table:"artist",
        external_id	: external_id,
        output:JSON_STRING
    }),
    

    removeArtists:(label_artist_id)=>MHTTPCL.post(LABEL_URL,{
        section	: "artists",
        action	:"remove_artists",
        label_artist_id	:label_artist_id
    })
    

    










    



    

    

    
    

    

    

}